import React, { useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const ContextMenu = ({ x, y, options, onClose }) => {
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [onClose]);

    return (
        <AnimatePresence>
            <motion.div
                ref={menuRef}
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.95 }}
                style={{
                    position: 'fixed',
                    top: y,
                    left: x,
                    zIndex: 1000,
                    backgroundColor: 'var(--bg-main)',
                    border: '1px solid var(--border-glass)',
                    borderRadius: '8px',
                    boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
                    padding: '4px',
                    minWidth: '180px',
                    backdropFilter: 'blur(10px)'
                }}
            >
                {options.map((option, index) => (
                    option.label === '---' ? (
                        <div key={index} style={{ height: '1px', backgroundColor: 'var(--border-glass)', margin: '4px 8px' }} />
                    ) : (
                        <div
                            key={index}
                            onClick={() => {
                                option.onClick();
                                onClose();
                            }}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                padding: '10px 12px',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                fontSize: '0.85rem',
                                color: option.danger ? '#ef4444' : 'var(--text-main)',
                                transition: 'all 0.2s ease',
                            }}
                            className="btn-hover-light"
                        >
                            {option.icon && <option.icon size={16} />}
                            <span>{option.label}</span>
                        </div>
                    )
                ))}
            </motion.div>
        </AnimatePresence>
    );
};

export default ContextMenu;
